/** Reviewed against Boverket on 2026-09-21. Recheck when the rules change. */
export const BUILDING_PERMISSION = {
  reviewedAt: "2026-09-21",
  summary:
    "Ett uterum som byggs till huset kan vara lovfritt inom reglerna för högst 30 m² sammanlagd lovfri tillbyggnad. Höjd, tidigare tillbyggnader, placering och skyddsbestämmelser måste också kontrolleras. Storleken ensam avgör inte om bygglov krävs.",
  notification:
    "Lovfrihet innebär inte att alla arbeten är anmälningsfria. Exempelvis väsentlig påverkan på bärande delar eller brandskydd samt vissa installationer kan kräva anmälan. När anmälan krävs behöver du startbesked innan det arbetet börjar.",
  local:
    "Kontrollera kommunens uppgifter om fastigheten, avstånd till gräns och järnväg samt eventuella kulturmiljö- och skyddsbestämmelser. Strandskydd bedöms separat från bygglov.",
  sources: [
    {
      label: "Boverket: tillbyggnad",
      href: "https://www.boverket.se/sv/PBL-kunskapsbanken/lov--byggande/anmalningsplikt/byggnader/tillbyggnad/annan-byggnad/",
    },
    {
      label: "Boverket: anmälan",
      href: "https://www.boverket.se/sv/pbl-kunskapsbanken/lov--byggande/anmalningsplikt/anmalan/",
    },
  ],
} as const;
